import { createContext, useContext, type ReactNode } from 'react';
import type { UserRole } from '../types/crm';

type AdminHubContextValue = {
  actorRole: UserRole;
};

const AdminHubContext = createContext<AdminHubContextValue | null>(null);

export function AdminHubProvider({
  actorRole,
  children,
}: {
  actorRole: UserRole;
  children: ReactNode;
}) {
  return (
    <AdminHubContext.Provider value={{ actorRole }}>{children}</AdminHubContext.Provider>
  );
}

export function useAdminHubContext(): AdminHubContextValue | null {
  return useContext(AdminHubContext);
}
